var defaultStyles = {
  "root": "Base-Textarea",
  "textarea": "Base-Textarea--Textarea",
  "label": "Base-Textarea--Label",
  "label_inset": "Base-Textarea--LabelInset",
  "label_active": "Base-Textarea--LabelActive",
  "textarea_wrapper": "Base-Textarea--TextareaWrapper",
  "textarea_inset": "Base-Textarea--TextareaInset",
  "hidden": "Base-Textarea--Hidden",
  "default": "Base-Textarea--Default",
  "filled": "Base-Textarea--Filled",
  "underlined": "Base-Textarea--Underlined",
  "error": "Base-Textarea--Error",
  "warning": "Base-Textarea--Warning",
  "success": "Base-Textarea--Success",
  "disabled": "Base-Textarea--Disabled",
  "limit": "Base-Textarea--Limit",
  "limit_inset": "Base-Textarea--LimitInset"
};

export { defaultStyles as default };
